import { FormControl, StepContent, TextField } from '@mui/material';
import { FormStepProps, ValueByStep } from '@pages/SavingsCalculator/types';

const ProvidersStep = ({ values, setStepValue }: FormStepProps) => {
  const handleVolumeChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setStepValue({
      newStep: ValueByStep.providers + 1,
      value: e.target.value,
    });
  };
  return (
    <StepContent>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <TextField
          value={values.step2}
          disabled={!values.step1}
          onChange={handleVolumeChange}
          placeholder="10"
        />
      </FormControl>
    </StepContent>
  );
};

export default ProvidersStep;
